import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Slider from '../../components/Slider/Slider';

import {
  Section,
  ReviewsContainer,
  SlideWrapper,
  ImageWrapper,
  Title,
  ContentText,
  QuoteWrapper,
  AuthorText,
  AuthorName,
} from './ProductReviews.style';
import Placeholder from '../Placeholder';

class ProductReviews extends Component {
  state = {
    currentSlide: 0,
  };

  handleSlideChange = i => {
    this.setState({
      currentSlide: i,
    });
  };

  render() {
    const { copy, reviews } = this.props;
    const { currentSlide } = this.state;

    return (
      <Section>
        <Title>{copy.stylists_reviews || <Placeholder w="135px" h="18px" />}</Title>

        <ReviewsContainer reviewNo={reviews ? reviews.length : 0}>
          {reviews ? (
            <Slider
              currentSlide={currentSlide}
              dots
              keys={reviews ? reviews.map(({ author }) => author.name) : []}
              options={{
                duration: 800,
                easing: 'ease-in-out',
                loop: true,
                onChange: this.handleSlideChange,
              }}
            >
              {reviews.map(({ author, content }) => (
                <SlideWrapper key={author.name}>
                  {author.image && (
                    <ImageWrapper>
                      <img
                        src={author.image.file.url}
                        width={author.image.file.details.image.width}
                        height={author.image.file.details.image.height}
                        style={{ width: '100%', height: 'auto', display: 'block' }}
                        alt="Review Author"
                      />
                    </ImageWrapper>
                  )}
                  <QuoteWrapper height={author.image ? 'auto' : '32em'}>
                    <ContentText>
                      <em>{content}</em>
                    </ContentText>
                    <AuthorText>
                      <AuthorName>{author.name}</AuthorName>
                      {author.title}, {author.location}
                    </AuthorText>
                  </QuoteWrapper>
                </SlideWrapper>
              ))}
            </Slider>
          ) : (
            <SlideWrapper>
              <ImageWrapper>
                <Placeholder w="100%" pb="calc(500% / 6)" />
              </ImageWrapper>

              <QuoteWrapper height="auto">
                <ContentText>
                  <Placeholder w="100%" pb="30%" />
                </ContentText>
                <AuthorText>
                  <AuthorName>
                    <Placeholder w="50%" h="20px" />
                  </AuthorName>
                  <Placeholder w="20%" h="20px" />, <Placeholder w="20%" h="20px" />
                </AuthorText>
              </QuoteWrapper>
            </SlideWrapper>
          )}
        </ReviewsContainer>
      </Section>
    );
  }
}

ProductReviews.defaultProps = {
  reviews: undefined,
  copy: {},
};

ProductReviews.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})),
  copy: PropTypes.shape(),
};

export default ProductReviews;



// WEBPACK FOOTER //
// ./src/components/ProductReviews/ProductReviews.js